(function ($) {
    $(function () {

    var languageSelectorContainer = $('.js-language-selector-inactive-wrapper')

    $(".js-language-selector").hoverIntent({
        over: animateLanguageSelectorIn,
        out: animateLanguageSelectorOut,
        timeout: 300,
    });

    function animateLanguageSelectorIn(e) {
        languageSelectorContainer.addClass('show');
        $(this).addClass('active');
    }

    function animateLanguageSelectorOut(e) {
        languageSelectorContainer.removeClass('show');
        $(this).removeClass('active');
    }
});
})(jQuery);